import { xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { LinkClickedEvent } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BannerDetailsWidget } from '@atlassian/mpac-primitives';
import { css } from '@compiled/react';
import React from 'react';

import { ANALYTICS_SUBJECT_ID_BANNER_DETAILS_CTA } from '../../../../../analytics/Events';
import useCTAClickHandler from '../../../../../hooks/useCTAClickHandler';
import {
  AI_HUB_BANNER,
  categories,
  dataTestIds,
  FIRST_FOCUSABLE_MENU_ELEMENT,
} from '../../constants';
import { DescriptiveItem } from '../../DescriptiveItem';
import { DescriptiveItemsContainer, EyebrowText } from '../../ExpandedMenus.styles';
import { ExpandedNavItemLayout } from '../../ExpandedNavItemLayout';
import { WhatsNew } from '../../WhatsNew';

import aiTeammate from '../../../../../assets/images/aiTeammate.svg';

const bannerStyles = css({
  backgroundColor: token('elevation.surface.sunken'),
  borderRadius: '1rem',
});

const borderStyles = xcss({
  borderTop: 'none',
});

export const Categories = ({
  closeMenu,
  focusFirstLinkUnderMenu,
}: {
  closeMenu: () => void;
  focusFirstLinkUnderMenu?: React.RefObject<HTMLAnchorElement>;
}) => {
  const { enableMpacAgentsPageView } = useStatsig();
  const handleCtaClick = useCTAClickHandler();
  const primaryContent = (
    <>
      <EyebrowText role="heading" aria-level={2}>
        Categories
      </EyebrowText>
      <DescriptiveItemsContainer>
        {categories.map((category, index) => (
          <DescriptiveItem
            id={index === 0 ? FIRST_FOCUSABLE_MENU_ELEMENT : undefined}
            key={category.id}
            iconUrl={category.icon}
            name={category.name}
            description={category.description}
            href={`/categories/${category.id}`}
            closeMenu={closeMenu}
            focusFirstLinkUnderMenu={focusFirstLinkUnderMenu}
          />
        ))}
      </DescriptiveItemsContainer>
      {enableMpacAgentsPageView() && (
        <div css={bannerStyles}>
          <BannerDetailsWidget
            iconImage={aiTeammate}
            text={AI_HUB_BANNER.text}
            subText={AI_HUB_BANNER.subText}
            ctaText={AI_HUB_BANNER.ctaText}
            ctaHref={AI_HUB_BANNER.ctaHref}
            ctaType={AI_HUB_BANNER.ctaType}
            containerStyles={borderStyles}
            ctaAriaLabel={AI_HUB_BANNER.ctaAriaLabel}
            onCtaClick={(event) => {
              closeMenu();
              handleCtaClick(
                event,
                LinkClickedEvent,
                ANALYTICS_SUBJECT_ID_BANNER_DETAILS_CTA,
                {
                  destinationUrl: AI_HUB_BANNER.ctaHref,
                  linkText: AI_HUB_BANNER.ctaText,
                  dropdownName: 'categories',
                },
                AI_HUB_BANNER.ctaHref
              );
            }}
          />
        </div>
      )}
    </>
  );

  return (
    <ExpandedNavItemLayout
      dataTestId={dataTestIds.EXPANDABLE_MENU__CATEGORIES}
      primaryContent={primaryContent}
      secondaryContent={<WhatsNew closeMenu={closeMenu} />}
    />
  );
};
